module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aLDn0"))).then(() => parcelRequire('fThBo'));